import { createSlice } from "@reduxjs/toolkit";

const tourSlice = createSlice({
  name: "tour",
  initialState: { running: false, tourType: null },
  reducers: {
    startTour: (state) => {
      state.running = true;
      state.tourType = "admin";
    },
    startMemberTour: (state) => {
      state.running = true;
      state.tourType = "member";
    },
    endTour: (state) => {
      state.running = false;
      state.tourType = null;
    },
  },
});

export const { startTour, startMemberTour, endTour } = tourSlice.actions;
export const selectTourRunning = (state) => state.tour.running;
export const selectTourType = (state) => state.tour.tourType;
export default tourSlice.reducer;
